import { createActions, createReducer } from 'reduxsauce'

const { Types, Creators } = createActions({
  rewardPointsRequest:         null,
  rewardPointsSuccess:         ['data'],
  rewardPointsFailure:         ['error'],
  rewardPointsHistoryRequest:  ['page', 'size'],
  rewardPointsHistorySuccess:  ['data'],
  rewardPointsHistoryFailure:  ['error'],
  redeemPointsRequest:        null,
  redeemPointsSuccess:        ['data'],
  redeemPointsFailure:        ['error'],
})

export const PointsTypes   = Types
export const PointsActions = Creators

const INITIAL_STATE = {
  rewardPointsLoading:        false,
  rewardPointsHistoryLoading: false,
  rewardPoints:               null,
  rewardPointsHistory:        null,
  rewardPointsError:          null,
  rewardPointsHistoryError:   null,
  redeemingPoints:            false,
  redeemPointsSuccess:        null,
  redeemPointsError:          null,
}

const rewardPointsRequest = (state) => ({
  ...state, rewardPointsLoading: true, rewardPoints: null, rewardPointsError: null,
})

const rewardPointsSuccess = (state, action) => ({
  ...state, rewardPointsLoading: false, rewardPoints: action.data,
})

const rewardPointsFailure = (state, action) => ({
  ...state, rewardPointsLoading: false, rewardPointsError: action.error,
})

const rewardPointsHistoryRequest = (state) => ({
  ...state, rewardPointsHistoryLoading: true, rewardPointsHistory: null, rewardPointsHistoryError: null,
})

const rewardPointsHistorySuccess = (state, action) => ({
  ...state, rewardPointsHistoryLoading: false, rewardPointsHistory: action.data,
})

const rewardPointsHistoryFailure = (state, action) => ({
  ...state, rewardPointsHistoryLoading: false, rewardPointsHistoryError: action.error,
})

const redeemPointsRequest = (state) => ({
  ...state, redeemingPoints: true, redeemPointsSuccess: null, redeemPointsError: null,
})

const redeemPointsSuccess = (state, action) => ({
  ...state, redeemingPoints: false, redeemPointsSuccess: action.data,
})

const redeemPointsFailure = (state, action) => ({
  ...state, redeemingPoints: false, redeemPointsError: action.error,
})

export default createReducer(INITIAL_STATE, {
  [Types.REWARD_POINTS_REQUEST]:         rewardPointsRequest,
  [Types.REWARD_POINTS_SUCCESS]:         rewardPointsSuccess,
  [Types.REWARD_POINTS_FAILURE]:         rewardPointsFailure,
  [Types.REWARD_POINTS_HISTORY_REQUEST]: rewardPointsHistoryRequest,
  [Types.REWARD_POINTS_HISTORY_SUCCESS]: rewardPointsHistorySuccess,
  [Types.REWARD_POINTS_HISTORY_FAILURE]: rewardPointsHistoryFailure,
  [Types.REDEEM_POINTS_REQUEST]:         redeemPointsRequest,
  [Types.REDEEM_POINTS_SUCCESS]:         redeemPointsSuccess,
  [Types.REDEEM_POINTS_FAILURE]:         redeemPointsFailure,
})
